
import $ from 'jquery';

export const init = ($target) => {
	// fixed bar

	$target.find('.js-fixed').each(function() {
		var $this  = $(this),
			$wrap = $this.find('.js-fixed__wrap'),
			$wrappedTarget = $this.find('.js-fixed__target--wrapped'),
			$target = $this.find('.js-fixed__target');


		$(window).on('scroll resize', function() {

			$wrap.height( $wrappedTarget.outerHeight() );
			$wrappedTarget.width( $wrappedTarget.parent().innerWidth() );


				if ( $this.outerHeight() > $target.outerHeight() ) {

					if ( $(document).scrollTop() + 600 > $this.offset().top) {

						$target.addClass('is-fixed');

						if ( $(document).scrollTop() + $target.height() > $this.offset().top + $this.outerHeight() ) {
							//$target.addClass('is-fixed-bottom');
							//$target.removeClass('is-fixed');
						}
						else {
							//$target.removeClass('is-fixed-bottom');
							$target.addClass('is-fixed');
						}

					}
					else {
						$target.removeClass('is-fixed');
					}
				}

		});
	});

	$target.find('.js-fixed-side').each(function() {

		var $this  = $(this),
			$target = $this.find('.js-fixed-side__target');

		$target.width( $target.parent().innerWidth() );

		$(window).on('scroll', function() {

			if ( $this.outerHeight() > $target.outerHeight() ) {

				if ( $(document).scrollTop() > $this.offset().top - 32 ) { // top fixed space (match CSS: $gridGutter*2)

					$target.addClass('is-fixed');

					if ( $(document).scrollTop() + $target.height() > $this.offset().top + $this.outerHeight() - 80 ) { // bottom fixed space
						$target.addClass('is-fixed-bottom');
					}
					else {
						$target.removeClass('is-fixed-bottom');
					}

				}
				else {
					$target.removeClass('is-fixed');
				}
			}

		});

		$(window).on('resize', function() {
			$target.width( $target.parent().innerWidth() );
		});

	});
};
